import { h } from 'preact';
import { ProductReturnPolicy } from 'utils/helpers';

const ProductReturnPolicyNotes = ({
  styleNumber,
  currentProduct,
  currentVariant,
  ...props
}) => {

  if (styleNumber == null){
    return false;
  }

  const productPolicy =  ProductReturnPolicy(
    currentProduct, styleNumber, currentVariant);
    
  if (!productPolicy.enabled) return false;
  
  return (
    <div {...props}>
       <div
        className='return-policy-notes'
        dangerouslySetInnerHTML={{
          __html: productPolicy.policynotes,
        }}
      ></div>
    </div>
  );
};

export default ProductReturnPolicyNotes;
